import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import topbarStype from './../../assets/jss/psstyle/component/topbarStype'
import { makeStyles } from '@mui/styles';


export default function BasicMenu(props) {

    const { listmenu, startIcon } = props
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        setAnchorEl(null);
        props.onClick(e)
    };

    return (
        <div className={topbarStype.Divs}>
            <Button
                id="basic-button"
                aria-controls="basic-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                startIcon={startIcon}
            >
                <span className={topbarStype.Buttons}>Key</span>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={e => handleClose()}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {listmenu.map((option, index) => (
                    <MenuItem key={index} onClick={e => handleClose(option[1])}><span className={topbarStype.txt}>{option[0]}</span></MenuItem>
                    // <MenuItem onClick={handleClose}>My account</MenuItem>
                    // <MenuItem onClick={handleClose}>Logout</MenuItem>

                ))}
            </Menu>
        </div>
    );
}

BasicMenu.prototype = {
    listmenu: PropTypes.array,
    startIcon: PropTypes.node
}